module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Second Chances")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('strong', [_vm._v("An inspiring collection of do-overs that have made people’s lives brighter.")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("ERIN McHUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "23",
      "src": "images/pub.jpg",
      "width": "205"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4f3bcde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/half.vue
// module id = 63
// module chunks = 0